import { TFunction } from 'i18next';

export interface Industries {
  [industry: string]: string;
}

export const getIndustries = (t: TFunction): Industries => ({
  healthWellness: t('signup-flow.industry.health-wellness'),
  educationCoaching: t('signup-flow.industry.education-coaching'),
  service: t('signup-flow.industry.service'),
  artDesign: t('signup-flow.industry.art-design'),
  photography: t('signup-flow.industry.portfolio-photography'),
  shop: t('signup-flow.industry.shop'),
  barCafeRestaurant: t('signup-flow.industry.bar-cafe-restaurant'),
  travelFreetime: t('signup-flow.industry.travel-freetime'),
  homeGarden: t('signup-flow.industry.home-garden'),
  fashion: t('signup-flow.industry.fashion'),
  ngoClub: t('signup-flow.industry.ngo-club'),
  personal: t('signup-flow.industry.personal'),
  blog: t('signup-flow.industry.blog'),
  other: t('signup-flow.industry.other-placeholder'),
  showAll: t('signup-flow.industry.show-all'),
});
